<template>
  <div class="background">

    <v-row>
      <v-col md="8" class="pa-0">
        <!-- PAGE -->
        <div class="noprint-frame">
          <v-row class="justify-end">
            <img class="mr-3" src="https://puravida-organic.com/wp-content/uploads/2019/10/playfair-display-outline.svg" width="300px" />
          </v-row>
          <div class="display-1 mt-4 mb-2">
            {{ Translation.get('Delivery', lang)}} {{ id }}
          </div>

          <v-layout class="mb-10">
            
            <v-flex xs6>

              <div>
                <span v-if="lang === 'hrk'">Datum: {{ date }}</span>
                <span v-else-if="lang === 'eng'">Date: {{ date }}</span>
              </div>

            </v-flex>
          </v-layout>

          <div class="c-hr"></div>

          <table :class="['final-table th-no-padding compact lines-b full-width']">
            <colgroup ref="colgroup1">
                <col width="20%">
                <col width="10%">
                <col width="15%">
                <col width="15%">
                <col width="8%">
            </colgroup>

            <tr>
              <c-table-header
              :title="Translation.get('Item', lang)"
              code="item"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Quantity', lang)"
              code="quantity"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Unit price', lang)"
              code="unit_price"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Total', lang)"
              code="total"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('VAT', lang)"
              code="vat"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
            </tr>

            <quote-row
            v-for="item in items" 
            :key="item.tempID"
            vmode="table"
            :currency="printSettings.currency"
            :rateMultiplier="rateMultiplier"
            :item="item"
            :selected="selected"
            :sortIndex="sortIndex"
            :searchText="searchText"
            ></quote-row>

          </table>

          <v-row>
            <v-col md="6">

            </v-col>
            <v-col md="6">
              <v-card class="elevation-0 pa-2">
                <table class="final-table compact full-width text-end">
                  <colgroup>
                    <col width="10px">
                    <col width="10px">
                  </colgroup>

                  <tr>
                    <td>
                      {{ Translation.get('Subtotal', lang) }}
                    </td>
                    <td>
                      <c-price :quantity="netTotalCostSumFixed" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Subtotal + VAT
                    </td>
                    <td>
                      <c-price :quantity="stotalPlusVatFixed" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                  </tr>

                </table>
              </v-card>
            </v-col>
          </v-row>

        </div>
        <!-- PAGE -->
      </v-col>

      <v-col md="4" class="noprint">
        <!-- SETTINGS -->
        <v-card outlined class="ml-4 mr-4" style="position: sticky; top: 20px;">
          <v-row class="pa-2">
            Print Settings
          </v-row>
          <div class="pa-4">
            <v-row class="align-center">
              <v-col md="3">
                <div class="label">Language:</div>
              </v-col>
              <v-col md="9">
                <select-language class="crx-box-input" selectedCode="eng" @change="onChangeLanguage"></select-language>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col md="3">
                <div class="label">Currency:</div>
              </v-col>
              <v-col md="9">
                <c-select-currency :selectedID.sync="printSettings.currency" class="crx-box-input" @change="onChangeCurrency"></c-select-currency>
              </v-col>
            </v-row>

            <!-- CONVERSION BLOCK -->
            <div v-show="conversionNecessary">
              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Conversion rate:</div>
                </v-col>
                <v-col md="9">
                  <v-row class="align-center caption">
                    {{ baseCurrencyLabel.symbol }}
                    <v-icon small>mdi-swap-horizontal</v-icon>
                    {{ printCurrencyLabel.symbol }}
                  </v-row>
                  <c-input :value.sync="printSettings.rate" class="crx-box-input"></c-input>
                  <!-- conversion warning -->
                  <div class="caption red--text">
                    * Make sure this conversion rate is correct
                  </div>
                </v-col>

                <automatic-currency-rate :currency="delivery.currency" @updateRate="updateRate" @updateRateAutomatic="updateRateAutomatic" :baseCurrency="printSettings.currency" class="mt-2"></automatic-currency-rate>
              </v-row>
            </div>

            <v-row class="justify-end mt-3">
              <v-btn @click="onPrint" color="color1" class="white--text">
                PRINT
              </v-btn>
            </v-row>
      
          </div>
        </v-card>
        <!-- SETTINGS -->
      </v-col>
    </v-row>

  </div>
</template>

<script>
import QuoteRow from './row'
import ListController from '@/mixins/ListController'
import Translation from '@/js/translations'
import SelectLanguage from '@/components/select/SelectLanguage'
import AutomaticCurrencyRate from '@/components/select/AutomaticCurrencyRate'
import {BigNumber} from 'bignumber.js'

export default {
  props: ['id'],
  components: {
    QuoteRow,
    SelectLanguage,
    AutomaticCurrencyRate
  },
  mixins: [ListController],
  data () {
    return {
      items: [],
      delivery: {},
      customer: {},
      lang: 'eng',
      Translation,
      printSettings: {
        currency: 47,
        rate: null
      }
    }
  },
  computed: {
    baseCurrencyLabel () {
      return this.$store.state.db.currencies.items[this.delivery.currency] || {}
    },
    printCurrencyLabel () {
      return this.$store.state.db.currencies.items[this.printSettings.currency] || {}
    },
    conversionNecessary () {
      if (this.delivery.currency !== this.printSettings.currency) {
        return true
      }
      return false
    },
    rateMultiplier () {
      if (!this.conversionNecessary) {
        return 1
      }
      return this.printSettings.rate || 1
    },
    totalWeight () {
      return this.items.reduce((a, i) => a + i.weight, 0)
    },
    netTotalCostSum () {
      return this.items.reduce((a, i) => {
        var add = new BigNumber(this.getQuantityInUnits(i)).times(i.cost_per_unit).toNumber()
        return a + add
      }, 0) * this.rateMultiplier
    },
    netTotalCostSumFixed() {     
      return Number(this.netTotalCostSum).toFixed(2)
    },
    stotalPlusVat () {
      return this.items.reduce((a, i) => {
        var add = new BigNumber(this.getQuantityInUnits(i)).times(i.cost_per_unit).toNumber()
        if (i.vat) {
          add += ((add * Number(i.vat)) / 100)
        }
        return a + add
      }, 0) * this.rateMultiplier
    },
    stotalPlusVatFixed () {
      return Number(this.stotalPlusVat).toFixed(2)
    },
    date () {
      return this.$moment(this.delivery.date).format('DD/MM/YYYY')
    },
  },
  methods: {
    getQuantityInUnits (item) {
      switch (item.definition.metric) {
        case 0:
          return item.quantity
        case 1:
          // ml - litres
          return new BigNumber(item.quantity).dividedBy(1000)
        case 2:
          // mg - kg
          return new BigNumber(item.quantity).dividedBy(1000 * 1000)
        case 3:
          // mm - m
          return new BigNumber(item.quantity).dividedBy(1000)
      }
    },
    updateRate (rate) {
      this.printSettings.rate = rate.rate
    },
    updateRateAutomatic (rate) {
      if (!this.printSettings.rate) {
        this.printSettings.rate = rate.rate
      }
      if (this.printSettings.currency !== this.delivery.currency) {
        this.printSettings.rate = rate.rate
      }

      if (this.printSettings.currency === this.delivery.currency) {
        this.printSettings.rate = 1
      }
    },

    async getDelivery () {
      var delivery = await this.$axios.get('/deliveries/' + this.id)
      var items = await this.$axios.get('/delivery-items/' + this.id)

      return {
        delivery: delivery.data,
        items: items.data
      }
    },

    reload () {
      this.getDelivery()
        .then(delivery => {
          this.items = delivery.items
          console.log(delivery.delivery)
          this.delivery = delivery.delivery
          this.delivery.currency = 47
          // this.printSettings.currency = response.invoice.currency
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onPrint () {
      window.print()
    },
    onChangeLanguage (nv) {
      this.lang = nv.code
    },
    onChangeCurrency (nv) {
      /* console.log(nv)
      var swapFound = Object.values(this.$store.state.db.currencyRates.items).find(item => item.currency_1 === this.invoice.currency && item.currency_2 === this.printSettings.currency)
      if (swapFound) {
        this.printSettings.rate = swapFound.rate
      } else {
        this.printSettings.rate = 1
      }
      */
    }
  },
  created () {
    this.reload()
  }
}
</script>

<style scoped lang="scss">
::v-deep.crx-box-input {
  background: #f7fafc!important; /* fallback for print mode */
}

.noprint-frame {
  margin: 20px;
  padding: 50px;
  background: white;
}

/* PRINTING */
@media print { 
  .noprint-frame { 
     margin: 0px!important;
     padding: 0px!important;
  } 
} 
</style>
